class Table extends HTMLElement {
    constructor() {
        super();
        this.attachShadow({ mode: "open" });
        this.data = {};
    }

    connectedCallback() {
        const tableData = this.querySelector('script[table-data]');

        if (tableData && tableData.textContent.trim()) {
            try {
                this.data = JSON.parse(tableData.textContent);
                tableData.remove();
                this.render();
            } catch (err) {
                console.error("Comparison table JSON data error", err);
            }
        }
    }

    render() {
        const headers = this.data.headers || [];
        const data = this.data.data || [];

        console.log(this.data.hiddenOnMobile);
        const hiddenOnMobile = new Set(this.data.hiddenOnMobile || []);

        const stylesheet = this.getAttribute('stylesheet');

        this.shadowRoot.innerHTML = `
            <link rel="stylesheet" href="${stylesheet}">
            <div class="table-wrapper" part="wrapper">
                <table class="comparison-table" part="table">
                    <thead part="thead">
                        <tr part="header-row">
                            ${headers.map((header, index) => this.renderHeader(header, index, hiddenOnMobile)).join("")}
                        </tr>
                    </thead>
                    <tbody part="tbody"></tbody>
                </table>
            </div>
        `;
        this.setData(data, hiddenOnMobile)
    }

    renderHeader(header, index, hiddenOnMobile) {
        const hasImg = !!header.img;
        const hasTitle = !!header.title;
        const hidden = hiddenOnMobile.has(index) ? ' class="hidden-mobile"' : "";

        const img = hasImg ? `<img src="${header.img}" alt="${header.title || ''}" part="header-img header-img-${index}">` : "";
        const title = hasTitle ? `<p part="header-title header-title-${index}">${header.title}</p>` : "";

        return `<th${hidden} part="header-cell header-cell-${index}">${img}${title}</th>`;
    }

    setData(data, hiddenOnMobile) {
        const tableBody = this.shadowRoot.querySelector("tbody");

        const rows = data.map(rowData => {
            const row = document.createElement("tr");
            const cells = rowData.map((cellData, index) => {
                const cell = document.createElement('td');
                if (hiddenOnMobile.has(index)) cell.classList.add('hidden-mobile');
                this.createData(cell, cellData);
                return cell;
            });
            row.append(...cells);
            return row;
        });
        tableBody.innerHTML = "";
        tableBody.append(...rows);
    }

    createData = (cell, data) => {
        if (typeof data !== 'object') {
            cell.textContent = data;
            return;
        }
        if (data.icon) cell.append(this.createIcon(data.icon, data.alt));
        if (data.class) cell.classList.add(data.class);
        if (data.text) {
            const p = document.createElement('p');
            p.textContent = data.text;
            cell.append(p);
        }
    }

    createIcon = (src, alt) => {
        const img = new Image();
        img.src = src;
        img.alt = alt;
        return img;
    }
}

customElements.define("styled-table", Table);
